import { useMemo } from 'react';
import { ORGANIZATION_STATUS_OPTIONS } from '../constants';

export const useOrganizationsFormFields = () => {
  return useMemo(
    () => [
      // Row 1: ID (Left) | Name (Right)
      {
        name: 'id',
        label: 'Organization ID',
        type: 'text' as const,
        required: true,
        placeholder: 'Enter organization ID',
        layout: { span: 12 },
        props: {
          size: 'large',
          maxLength: 30,
        },
        tooltip: 'Unique identifier for the organization (max 30 characters)',
      },
      {
        name: 'name',
        label: 'Organization Name',
        type: 'text' as const,
        required: true,
        placeholder: 'Enter organization name',
        layout: { span: 12 },
        props: {
          size: 'large',
          maxLength: 30,
        },
        tooltip: 'Name of the organization (max 30 characters)',
      },

      // Row 2: Contact Email (Left) | Contact Mobile (Right)
      {
        name: 'contact_email',
        label: 'Contact Email',
        type: 'email' as const,
        required: true,
        placeholder: 'Enter contact email',
        layout: { span: 12 },
        props: {
          size: 'large',
          maxLength: 30,
          resourceAutoComplete: 'email',
        },
        tooltip: 'Primary contact email for the organization',
      },
      {
        name: 'contact_mobile_no',
        label: 'Contact Mobile',
        type: 'telephone' as const,
        required: true,
        placeholder: 'Enter contact mobile number',
        layout: { span: 12 }, // Right column
        props: {
          size: 'large',
          defaultCountry: 'IN',
          international: false,
          withCountryCallingCode: false,
          maxLength: 10,
        },
        validation: {
          pattern: '^[6-9]\\d{9}$',
          message:
            'Please enter a valid 10-digit mobile number starting with 6-9',
        },
        tooltip: 'Enter 10-digit mobile number (without country code)',
      },

      // Row 3: Status (Left)

      {
        name: 'status',
        label: 'Status',
        type: 'select' as const,
        required: true,
        placeholder: 'Select organization status',
        layout: { span: 12 },
        options: ORGANIZATION_STATUS_OPTIONS,
        props: {
          size: 'large',
        },
        tooltip: 'Current status of the organization',
      },
    ],
    []
  );
};